import { render } from "./LoyaltyLoginSuccess.vue?vue&type=template&id=ddeec31c&scoped=true"
import script from "./LoyaltyLoginSuccess.vue?vue&type=script&lang=js"
export * from "./LoyaltyLoginSuccess.vue?vue&type=script&lang=js"

import "./LoyaltyLoginSuccess.vue?vue&type=style&index=0&id=ddeec31c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddeec31c"]])

export default __exports__